import RelatedHub from './_hub';

// 関連サイト一覧(JA)。本文は _hub.tsx、カードは src/data/related、FAQ は src/data/faq.json(/related)。
export default function RelatedHubPage() {
  return <RelatedHub lang="ja" />;
}
